// Close-to-resolving banner — view event. Fires once per banner mount when
// the leading outcome's conviction enters the close-to-resolving window
// (see spec 102). Distinct from `market_detail_viewed` so the funnel can
// attribute the "approaching resolution" surface separately. Re-fires on
// re-entry (unmount → re-mount when the visibility predicate flips off
// then on) so each entry contributes a single attribution event.

import type { EventDefinition } from './navigation';

// Use `type` (not `interface`) so the payload satisfies the
// `Record<string, unknown>` constraint that `EventDefinition` enforces —
// same convention as every other event payload in `src/events/`.
export type MarketApproachingResolutionViewedProperties = {
  marketPubkey: string;
  outcomeIndex: number;
  /** Leading outcome's conviction as a fraction of the resolution threshold,
   *  rounded to the nearest integer percent (typically 90–99). */
  convictionPct: number;
  /** Estimated seconds until resolution at the current conviction target,
   *  or `null` when the estimate is unavailable (target ≤ threshold,
   *  retention out of domain, etc.). */
  ttrSeconds: number | null;
};

export const MARKET_APPROACHING_RESOLUTION_VIEWED: EventDefinition<MarketApproachingResolutionViewedProperties> =
  {
    name: 'market_approaching_resolution_viewed',
  };
